<span [pTooltip]="disabledReason() ?? ''" tooltipPosition="left">
    <p-button
        [label]="'Generate with AI'"
        [icon]="aiIcon"
        severity="secondary"
        [text]="true"
        size="small"
        [disabled]="disabled() || !hasTitle()"
        (click)="open()"
    />
</span>

<p-dialog
    header="AI — social preview image"
    [visible]="visible()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '52rem' }"
    [breakpoints]="{ '1024px': '95vw' }"
    [modal]="true"
    [closable]="phase() !== 'loading'"
    [draggable]="false"
>
    <div class="flex flex-col gap-4">
        @if (error(); as e) {
        <p-message
            severity="error"
            icon="pi pi-times-circle"
            styleClass="w-full"
        >
            <span class="text-sm">{{ e }}</span>
        </p-message>
        }

        <!-- form -->
        @if (phase() === 'form') {
        <div class="flex flex-col gap-4">
            <small class="text-muted-color">
                Overlays the brand name <b>{{ title() }}</b> and a tagline onto
                the template's text‑free base plate (output forced to 1200×630).
            </small>

            <div>
                <div class="block font-medium mb-1 text-sm">
                    Base plate <span class="font-normal text-muted-color">(from the template)</span>
                </div>
                @if (ogBasePlate(); as plate) {
                <div class="rounded border border-surface-200 dark:border-surface-700 bg-surface-100 dark:bg-surface-800 overflow-hidden">
                    <img [src]="plate.dataUrl" alt="OG base plate" class="w-full object-contain" />
                </div>
                } @else {
                <small class="text-amber-600">This template ships no OG base plate.</small>
                }
            </div>

            <div>
                <label for="og-tagline" class="block font-medium mb-1 text-sm"
                    >Tagline</label
                >
                <input
                    pInputText
                    id="og-tagline"
                    class="w-full"
                    placeholder="example: Your social gaming platform"
                    [ngModel]="tagline()"
                    (ngModelChange)="tagline.set($event ?? '')"
                />
                <small class="text-muted-color">
                    Prefilled from the SEO description — edit if you want a
                    different line on the card.
                </small>
            </div>

            <div>
                <label class="block font-medium mb-1 text-sm">Variants</label>
                <p-selectbutton
                    [options]="sampleOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="samples()"
                    (ngModelChange)="samples.set($event ?? 4)"
                    [allowEmpty]="false"
                />
            </div>

            @if (creditBlock(); as block) {
            <p-message severity="warn" icon="pi pi-wallet" styleClass="w-full">
                <span class="text-sm">{{ block }}</span>
            </p-message>
            }

            <div class="flex justify-end">
                <p-button
                    label="Generate"
                    [icon]="aiIcon"
                    [disabled]="!canGenerate()"
                    (click)="generate()"
                />
            </div>
        </div>
        }

        <!-- loading -->
        @if (phase() === 'loading') {
        <div class="flex flex-col items-center justify-center gap-3 py-10">
            <p-progress-spinner
                styleClass="w-12 h-12"
                strokeWidth="4"
                ariaLabel="Generating"
            />
            <div class="text-sm text-muted-color">
                Generating {{ samples() }} preview(s) — this can take up to a
                minute…
            </div>
        </div>
        }

        <!-- results -->
        @if (phase() === 'results') {
        <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between">
                <div class="text-sm text-muted-color">
                    Pick a social preview image to apply.
                </div>
                <p-button
                    label="Back"
                    icon="pi pi-arrow-left"
                    severity="secondary"
                    outlined
                    size="small"
                    (click)="backToForm()"
                />
            </div>

            @if (candidates().length === 0) {
            <p-message severity="warn" styleClass="w-full">
                <span class="text-sm">No candidates were returned.</span>
            </p-message>
            } @else {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                @for (c of candidates(); track c.url) {
                <div
                    class="rounded border border-surface-200 dark:border-surface-700 overflow-hidden flex flex-col"
                >
                    <img
                        [src]="c.url"
                        alt="Social preview candidate"
                        class="w-full object-cover bg-surface-100 dark:bg-surface-800"
                        referrerpolicy="no-referrer"
                    />
                    <div
                        class="flex items-center justify-end px-2 py-1.5 border-t border-surface-200 dark:border-surface-700"
                    >
                        <p-button
                            label="Use"
                            icon="pi pi-check"
                            size="small"
                            (click)="use(c)"
                        />
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
</p-dialog>
